import clsx from 'clsx';

const shimmer =
    'before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/60 before:to-transparent';

export default function LoadingPlaceholder({
    className,
}: Readonly<{
    className?: string;
}>) {
    return (
        <div
            aria-hidden="true"
            className={clsx(
                'relative overflow-hidden rounded-full bg-gray-100',
                shimmer,
                className,
            )}
        />
    );
}
